import { render, staticRenderFns } from "./OrderCreated.vue?vue&type=template&id=706ca40e&scoped=true"
import script from "./OrderCreated.vue?vue&type=script&lang=js"
export * from "./OrderCreated.vue?vue&type=script&lang=js"
import style0 from "./OrderCreated.vue?vue&type=style&index=0&id=706ca40e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "706ca40e",
  null
  
)

export default component.exports